import type { Model } from 'modules/core/lib/mobx-rest'
import { Collection } from 'modules/core/lib/mobx-rest'

import CustomField from 'modules/custom_resources/store/models/customFields/Field'

export interface ModelWithCustomFieldIdentifier {
  customFieldsIdentifier: () => string
}

export class CustomFieldsByGroupCollection extends Collection<CustomField> {
  get cacheKey(): string {
    return 'customFieldsByGroup'
  }

  model() {
    return CustomField
  }

  createForGroup(group: string, data: Record<string, string | number>) {
    return this.create({ ...data, usage_group_slug: [group] })
  }

  byUsageGroup(groups: string[]): Promise<any> {
    return this.fetch({
      data: {
        usage_group_slug: groups,
      },
    })
  }

  async createForResource(group: string, model: Model, data: Record<string, any>) {
    const customFieldModel = model as any as ModelWithCustomFieldIdentifier
    const identifier = customFieldModel.customFieldsIdentifier()

    if (!identifier) {
      throw new Error(`Unexpected identifier for this model: ${model}`)
    }

    const value = await this.rpc('create_for_resource', {
      ...data,
      usage_group_slug: [group],
      model: identifier,
      instance_id: model.attributes.id,
    })
    this.add(value)

    return value
  }
}

export default new CustomFieldsByGroupCollection()
